import { render, staticRenderFns } from "./AddMentorGroupDialogCpt.vue?vue&type=template&id=f3b1d47a&scoped=true&"
import script from "./AddMentorGroupDialogCpt.vue?vue&type=script&lang=ts&"
export * from "./AddMentorGroupDialogCpt.vue?vue&type=script&lang=ts&"
import style0 from "./AddMentorGroupDialogCpt.vue?vue&type=style&index=0&id=f3b1d47a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b1d47a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VCol,VDialog,VForm})
